<div class="relative rounded-lg overflow-hidden">
  <video controls [src]="message.mediaUrl" class="w-full h-auto rounded"></video>
  @if (!message.text && message.creationDate) {
    <div class="msg-time-overlay">{{ message.creationDate | date: messageDateFormat }}</div>
  }
</div>
@if(message.text){
  <p class="p-2">{{ message.text }}</p>
}
